export const getLabelByField = field => (
	opportunityFields.find(f => f.field === field) ? opportunityFields.find(f => f.field === field).label : field
);

export const opportunityFields = [
  { label: "Opportunity Owner", field: "Owner_First_Name__c", isVisible: true },
  { label: "Opportunity Name", field: "Name", isVisible: true, isDefault: true },
  { label: "Account Name", field: "Account.Name", isVisible: true , isDefault: true },
  { label: "End Customer", field: "End_Customer__r.Name", isVisible: true, isDefault: true },
  { label: "Opportunity Type", field: "Activity_Type__c", isVisible: true },
  { label: "Cloud POC", field: "Cloud_POC__r.Name", isVisible: true },
  { label: "Leading Cloud", field: "Leading_Cloud__c", isVisible: true },
  { label: "Customer Status", field: "Customer_Status__c", isVisible: true, isDefault: true },
  { label: "Stage Name", field: "StageName", isVisible: true ,isDefault: true },
  { label: "Probability (%)", field: "Probability", isVisible: true },
  { label: "Priority", field: "Priority__c", isVisible: true, isDefault: true },
  { label: "Opportunity Heat", field: "Opportunity_Heat__c", isVisible: true },
  { label: "ISV Opportunity Owner", field: "ISV_Opportunity_Owner__c", isVisible: true },
  { label: "ISV Opportunity Stage", field: "ISV_Opportunity_Stage__c", isVisible: true },
  { label: "Close Date", field: "CloseDate", isVisible: true },
  { label: "Is for Marketplace", field: "Is_for_Marketplace__c", isVisible: true },
  { label: "Propensity to Buy", field: "Propensity_to_Buy__c", isVisible: true },
  { label: "ACE Partner Center Status", field: "ACE_Partner_Center_Status__c", isVisible: true },
  { label: "Is on ACE", field: "Is_on_ACE_PSC__c", isVisible: true },
  { label: "Use Case Details", field: "Use_Case_Details__c", isVisible: true },
  { label: "Unique Identifier", field: "Unique_Identifier__c", isVisible: true },
  { label: "Description", field: "Description__c", isVisible: true },
  { label: "Next Step", field: "NextStep", isVisible: true },
  { label: "Next Step Date", field: "Next_Step_Date__c", isVisible: true },
  { label: "Next Step POC", field: "Next_Step_POC__r.Name", isVisible: true },
  { label: "Next Step Owner", field: "Next_Step_Owner__r.Name", isVisible: true },
  { label: "Account Team First Call", field: "Account_Team_First_Call__c", isVisible: true },
  { label: "Customer First Meeting", field: "Customer_First_Meeting__c", isVisible: true },
  { label: "On Hold?", field: "On_Hold__c", isVisible: true },
  { label: "Campaign", field: "Campaign__c", isVisible: true },
  { label: "Amount", field: "Amount", isVisible: true },
  { label: "Amount (CONNACT)", field: "Amount_CONNACT__c", isVisible: true },
  { label: "Deal Term (M)", field: "Deal_Term_M__c", isVisible: true },
  { label: "MRR", field: "MRR__c", isVisible: true },
  { label: "Payment Terms", field: "Payment_Terms__c", isVisible: true },
  { label: "Contract Effective Date", field: "Contract_Effective_Date__c", isVisible: true },
  { label: "Renewal Date", field: "Renewal_date__c", isVisible: true },
  { label: "Lost Reason", field: "Lost_Reason__c", isVisible: true },
  { label: "Created By", field: "CreatedBy.Name", isVisible: true },
  { label: "Last Modified By", field: "LastModifiedBy.Name", isVisible: true },
  { label: "CONNACT AM Email", field: "CONNACT_AM_Email__c", isVisible: true }
];
export const getDefaultFields = () => opportunityFields.filter(f => f.isDefault);
/**
 * @param {string[] | null} keys
 */
export const getDisplayFields = (isDefault=false,keys = null) => {
  const visibleFields = opportunityFields
  .filter(f => f.isVisible)
  .filter(f => isDefault ? f.isDefault : true);
;

  if (!keys||keys.length==0) return visibleFields;

  return keys
    .map(key => visibleFields.find(f => f.field === key))
    .filter(Boolean);
};
 const dashboardReportFileds =  [
        'Id',
				'StageName',
				'Name',
				'Leading_Cloud__c',
				'Activity_Type__c',
				'Cloud_POC__r.Name',
				'End_Customer_Region__c',
				'End_Customer_HQ__c',
				'Last_Stage_Change_Date_internal__c',
				'ISV_Opportunity_Owner__r.Name',
				'ISV_Opportunity_Stage__c',
				'Customer_Status__c',
				'Priority__c',
				'Last_Meeting_Date__c',
				'NextStep',
				'Next_Step_Date__c',
				'Next_Step_Owner__r.Name',
				'Opportunity_Heat__c',
				'Is_on_ACE_PSC__c',
				'ACE_Partner_Center_Status__c',
				'Is_for_Marketplace__c'
			];
export const getDashboardDisplayFields = (isDefault=false,keys = null,) => {
  const visibleDashboardFields = dashboardReportFileds
    .map(field => opportunityFields.find(f => f.field === field))
    .filter(Boolean)
    .filter(f => isDefault ? f.isDefault :true)
    // .map(f => ({ ...f,/ isVisible: true }));

  if (!keys||keys.length==0) return visibleDashboardFields;

  return keys
    .map(key => visibleDashboardFields.find(f => f.field === key))
    .filter(Boolean);
};
